import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    title: {
        id: "article.rhytname.hello.title",
    },
    description: {
        id: "article.rhytname.hello.description",
    },
});

export default messages;
